import { Options } from '@angular-slider/ngx-slider';
import { RRIInput } from '../../form-inputs/interfaces/input-settings.interface';

export class RRAvatarGeneratorInputSettingsModel {
  id: string;
  model: number;
  meassurementValue: number;
  settings: RRIInput<string>;
  disable: boolean;
  sliderOptions: Options;
}
